module.exports = "/_next/static/images/00f04a577e5254c51f897bdfddfa7d98-robot-lg.png.webp";